import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreDirectives } from '@core/directives/core.directives';
import { HelperFormModule } from '@core/components/helpers/form/form.module';
import { HelperBoxModule } from '@core/components/helpers/box/box.module';
import { FilesModule } from '@core/components/files/files.module';
import { CoreLayoutFloatModule } from '@core/components/layout/float/float.module';
import { HelpersEditorModule } from '@core/components/helpers/editor/editor.module';
import { HelperSsoModule } from '@core/components/helpers/sso/sso.module';

import { LayoutModalFeedbackComponent } from './modal-feedback/modal-feedback.component';
import { LayoutModalMessageOneActionComponent } from './modal-message-one-action/modal-message-one-action.component';
import { LayoutModalMessageTwoActionComponent } from './modal-message-two-action/modal-message-two-action.component';
import { LayoutModalInputComponent } from './modal-input/modal-input.component';
import { LayoutModalRecordComponent } from './modal-record/modal-record.component';
import { LayoutModalRecordPlayerComponent } from './modal-record-player/modal-record-player.component';
import { CoreLayoutOverlappedModalsComponent } from './overlapped/modals-overlapped.component';
import { LayoutModalSignatureComponent } from './modal-signature/modal-signature.component';
import { LayoutModalCfr11DigitalSignatureComponent } from './modal-cfr11-digital-signature/modal-cfr11-digital-signature.component';



@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CoreDirectives,
        HelperFormModule,
        HelperBoxModule,
        FilesModule,
        CoreLayoutFloatModule,
        HelpersEditorModule,
        HelperSsoModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        LayoutModalFeedbackComponent,
        LayoutModalMessageOneActionComponent,
        LayoutModalMessageTwoActionComponent,
        LayoutModalInputComponent,
        LayoutModalRecordComponent,
        LayoutModalRecordPlayerComponent,
        CoreLayoutOverlappedModalsComponent,
        LayoutModalSignatureComponent,
        LayoutModalCfr11DigitalSignatureComponent
    ],
    exports: [
        LayoutModalFeedbackComponent,
        LayoutModalMessageOneActionComponent,
        LayoutModalMessageTwoActionComponent,
        LayoutModalInputComponent,
        LayoutModalRecordComponent,
        LayoutModalRecordPlayerComponent,
        CoreLayoutOverlappedModalsComponent,
        LayoutModalSignatureComponent,
        LayoutModalCfr11DigitalSignatureComponent
    ],

})
export class LayoutModalsModule { }
